<template>
  <main class="body" role="main" id="main">
    <sc-placeholder tag="section" :rendering="rendering" name="digital-house-notes-layout"/>
  </main>
</template>

<script>

import UIMixin from '~/mixins/ui'

import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'

export default {
  name: 'DotcomHomePage',
  authenticated: true,
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  components: {
    scPlaceholder: Placeholder
  },
  mixins: [
    UIMixin
  ]
}
</script>

<style lang="scss" scoped>

.title {
  @include font('090');
  padding: $space-030 $space-060 $space-050 $space-060;
  
  @include tablet {
    @include font('100');
  }
}

main.body {
  > section,
  .recommended-wrapper {
    max-width: 1280px;
    margin: auto;
    width: 100%;
    padding: $space-060;

    @include breakpoint(small) {
      padding: $d-med;
    }

    @include tablet {
      padding: $d-large;
    }

    @include desktop {
      padding: $d-xx-large;
    }

    &:nth-of-type(2) {
      padding-top: 0;
    }
  }
}

::v-deep header.page-header div.page-header-content h1.house-notes-logo {
      margin-bottom: 0;
}

</style>
